import { mediaQueriesBP } from "@iewc/Utilities/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Link from "@insite/mobius/Link";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface LogInPriceStyles {
    logInPrice?: InjectableCss;
}

interface OwnProps {
    title: string;
}


const mapStateToProps = (state: ApplicationState) => {
    return {
        productSettings: getSettingsCollection(state).productSettings,
        userName: state.context.session.userName,
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentUserIsGuest: getCurrentUserIsGuest(state),
        currentLocation: getLocation(state),
    };
};

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;

const logInPriceStyles: LogInPriceStyles = {
    logInPrice: {
        css: css`
            ${mediaQueriesBP.maxMD} {
                display: flex;
                padding-bottom: 15px;
                justify-content: center;
            }
            span {
                font-size: 15px;
            }
        `,
    },
};

const logInPrice = ({ userName, signInUrl, currentUserIsGuest, currentLocation, history, title }: Props) => {
    const onSignInHandler = (e: React.MouseEvent) => {
        if (!userName || currentUserIsGuest) {
            e.preventDefault();
            const returnUrl = currentLocation.pathname + currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${signInUrl}`);
            } else {
                history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
            }
        }
    };

    if (userName) {
        return null;
    }

    return (
        <StyledWrapper {...logInPriceStyles.logInPrice}>
            <Link onClick={onSignInHandler} href={!signInUrl ? "/MyAccount/SignIn" : signInUrl}>
                {title}
            </Link>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(withHistory(logInPrice));
